// ─── Agent Library guided tour ────────────────────────────────────────────────
// A sibling of the PAIC tour (PeoplePlusAIV2.constants), not a replacement.
// Spec: agent-library-tour-elements.xlsx (reviewed). Agents Table, Empty State,
// Group Tag, Financial Columns and the Finish modal were removed in review, so the
// tour ends on the agent-row step and only runs when the library has agents.
export const TOUR_MODULE_KEY = "agent-library";

export const TOUR_STEPS = [
  {
    // Welcome — centered greeting
    title: "Welcome to the Agent Library",
    description:
      "This is where you will find all the selected AI agents, across every group and version, in one place. Let's take a quick look around.",
    primaryText: "Start the Tour",
    secondaryText: "I'll explore on my own",
  },
  {
    key: "viewToggle",
    title: "View By: Agents / Groups",
    description:
      "Switch between Agent view (one row per agent) and Group view (all agents gathered under the PAIC group that produced them).",
    placement: "bottom",
  },
  {
    key: "search",
    title: "Search",
    description:
      "Search across agent names, codes, descriptions, groups, versions and status.",
    placement: "bottom",
  },
  {
    // Spotlights the first row of the Agent view table (the tour switches to it).
    key: "agentRow",
    title: "Navigate Agent Details",
    description:
      "Click any agent to view agent details and download PRD. Click on the group name to go to that specific PAIC group detail page.",
    placement: "top",
  },
];
